import { z } from 'zod';

/** bigint primary keys cross HTTP as decimal strings — never as JS numbers (ADR 0006). */
export const idSchema = z.string().regex(/^[1-9]\d{0,18}$/, 'Nederīgs ID');
export type Id = z.infer<typeof idSchema>;

export const idParamSchema = z.object({ id: idSchema });
